import { render, staticRenderFns } from "./OverviewLabour.vue?vue&type=template&id=a1e11c98&scoped=true"
import script from "./OverviewLabour.vue?vue&type=script&lang=js"
export * from "./OverviewLabour.vue?vue&type=script&lang=js"
import style0 from "./OverviewLabour.vue?vue&type=style&index=0&id=a1e11c98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e11c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1e11c98')) {
      api.createRecord('a1e11c98', component.options)
    } else {
      api.reload('a1e11c98', component.options)
    }
    module.hot.accept("./OverviewLabour.vue?vue&type=template&id=a1e11c98&scoped=true", function () {
      api.rerender('a1e11c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OverviewLabour.vue"
export default component.exports